import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LinkedInCallback = () => {
  const location = useLocation();

  useEffect(() => {
    
    // Extract code and state from URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');
    
    // Check if we have an opener reference
    const hasOpener = window.opener && !window.opener.closed;
    
    if (!hasOpener) {
      // Fallback: redirect to login page
      setTimeout(() => {
        window.location.href = '/en/auth/login?error=popup_closed';
      }, 2000);
      return;
    }
    
    if (code) {
      try {
        // Send message to opener
        window.opener.postMessage({ 
          type: 'LINKEDIN_SUCCESS', 
          code,
          state 
        }, window.location.origin);
        
        
        // Clear the stored state
        sessionStorage.removeItem('linkedin_oauth_state');
        
        // Give time for message to be processed before closing
        setTimeout(() => {
          window.close();
        }, 500);
        
      } catch (err) {
        setTimeout(() => {
          window.location.href = '/en/auth/login?error=message_failed';
        }, 2000);
      }
    } else if (error) {
      try {
        window.opener.postMessage({ 
          type: 'LINKEDIN_ERROR', 
          error: errorDescription || error 
        }, window.location.origin);
        
        // Clear the stored state
        sessionStorage.removeItem('linkedin_oauth_state');
        
        setTimeout(() => {
          window.close();
        }, 500);
      } catch (err) {
        setTimeout(() => {
          window.location.href = `/en/auth/login?error=${encodeURIComponent(errorDescription || error)}`;
        }, 2000);
      }
    } else {
      
      try {
        window.opener.postMessage({ 
          type: 'LINKEDIN_ERROR', 
          error: 'Missing authorization code from LinkedIn' 
        }, window.location.origin);
        
        setTimeout(() => {
          window.close();
        }, 500);
      } catch (err) {
        setTimeout(() => {
          window.location.href = '/en/auth/login?error=missing_code';
        }, 2000);
      }
    }
  }, [location]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Completing LinkedIn Login...</h2>
        <p className="text-gray-600 mb-4">Please wait while we process your authentication.</p>
        <div className="flex justify-center mb-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
        <p className="text-sm text-gray-500">
          This window should close automatically. If it doesn't, you can close it manually.
        </p>
      </div>
    </div>
  );
};

export default LinkedInCallback;